import * as React from 'react'

function SvgComponent(props: React.SVGProps<SVGSVGElement>): JSX.Element {
  return (
    <svg width={15} height={16} viewBox="0 0 15 16" {...props}>
      <path
        d="M11.532 9.994c-.793 0-1.5.384-1.953.977L5.79 8.823a2.546 2.546 0 00-.003-1.654l3.785-2.146a2.45 2.45 0 001.956.983c1.357 0 2.465-1.122 2.465-2.503C13.994 2.123 12.89 1 11.53 1c-1.36 0-2.466 1.122-2.466 2.503 0 .29.05.57.14.828L5.422 6.477a2.441 2.441 0 00-1.956-.983C2.108 5.494 1 6.616 1 7.997 1 9.377 2.108 10.5 3.468 10.5c.796 0 1.506-.387 1.959-.985l3.785 2.148a2.526 2.526 0 00-.143.834c0 1.378 1.105 2.503 2.466 2.503C12.895 15 14 13.878 14 12.497c0-1.38-1.108-2.503-2.468-2.503zm0-8.206c.933 0 1.692.77 1.692 1.718 0 .947-.759 1.718-1.692 1.718-.934 0-1.693-.77-1.693-1.718s.762-1.718 1.693-1.718zM3.468 9.715c-.933 0-1.692-.77-1.692-1.718S2.535 6.28 3.468 6.28c.934 0 1.693.77 1.693 1.718s-.762 1.718-1.693 1.718zm8.064 4.497c-.934 0-1.693-.77-1.693-1.718 0-.947.76-1.718 1.693-1.718s1.692.77 1.692 1.718-.759 1.718-1.692 1.718z"
        fill="#000"
        fillRule="nonzero"
        stroke="#000"
        strokeWidth={0.3}
      />
    </svg>
  )
}

export default SvgComponent
